import React, { useContext, useEffect, useRef } from 'react'
import { Outlet, useSearchParams } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import { AppContext } from '@context/store'
import Swal from 'sweetalert2'

import { getHeaderEnrichment } from '@services/headerEnrichment';
// import { fetchKeywords } from '@services/wpApi';
import Navbar from '@components/Navbar'
// import Infotainment from './Infotainment';
// import Indico from './Indico';

const Base = () => {
  const { setStore, store: {
    serviceName
  }} = useContext(AppContext);
  const { isLoading, data } = useQuery(['header-enrichment'], getHeaderEnrichment);
  const [searchParams] = useSearchParams();
  const hasShownError = useRef(false);
  // const queryClient = useQueryClient();

  useEffect(() => {
    if (!isLoading) {
      setStore(prev => ({
        ...prev,
        user: {
          ...prev.user,
          msisdn: data
        }
      }));
    }
    // queryClient.prefetchQuery(['keywords', serviceName], () => fetchKeywords(serviceName));
  }, [data, isLoading]); // eslint-disable-line

  useEffect(() => {
    const hasError = searchParams.get('error');
    if (hasError === 'true' && !hasShownError.current) {
      hasShownError.current = true;
      Swal.fire({
        icon: 'error',
        text: 'An error occurred. Please try again.',
        toast: true,
        position: 'top',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true
      });
    }
  }, [searchParams]);

  if(! serviceName) return <>
    we couldn't identify your service
  </>;

  return (
    <>
      <Navbar />
      <div className="pt-6">
        <Outlet />
      </div>
    </>
  )
}

export default Base
